module.exports = __webpack_public_path__ + "media/images/products/wedding/img-feature-fee-94bf40ebf8f18f7736fad5c2c12c8bb4.png";